export type WhyWeService = {
  iconSrc: string;
  title: string;
  description: string;
  target: string;
};

export const SERVICES: WhyWeService[] = [
  {
    iconSrc: 'icons/reliable-service.svg',
    title: 'Reliable Service',
    description:
      'Our well-maintained fleet and skilled drivers guarantee the safe and timely delivery of your products.',
    target: 'safe and timely delivery',
  },
  {
    iconSrc: 'icons/startegic-locations.svg',
    title: 'Strategic Locations',
    description:
      'Our strategically placed locations across key markets ensure faster transit times and wider coverage.',
    target: 'strategically placed locations',
  },
  {
    iconSrc: 'icons/availability.svg',
    title: '24/7 Availability',
    description:
      'Our dedicated team is available around the clock to support your operations, providing solutions whenever you need them.',
    target: 'available around the clock',
  },
  {
    iconSrc: 'icons/cost-efficiency.svg',
    title: 'Cost-Efficiency',
    description:
      'By outsourcing your transportation needs to us, you reduce the costs associated with in-house fleet.',
    target: 'reduce the costs',
  },
  {
    iconSrc: 'icons/sustainability.svg',
    title: 'Sustainability',
    description:
      'We are dedicated to sustainable practices, working to reduce carbon footprint promoting eco-solutions.',
    target: 'reduce carbon footprint',
  },
];
